import { getConstant } from '../utils';

export const getUnitMeasurements = getConstant('GET_UNIT_MEASUREMENTS');
export const getUnitMeasurement = getConstant('GET_UNIT_MEASUREMENT');
